import React from "react";
import { AvailableFilters, JobStatus } from "@utils/enums";
import JobStatusIcon from "@components/Icon/JobStatusIcon";
import { getFilters } from "@store/selectors/pdf";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useSelector } from "react-redux";
const jobStatusMapping = [
    JobStatus.NEW,
    JobStatus.VALIDATED,
    JobStatus.IN_PROGRESS,
    JobStatus.FINISHED,
    JobStatus.FAILED,
    JobStatus.APP_ERROR
];
const JobStatusFilter = (props) => {
    const filters = useSelector(getFilters);
    const selectFilter = (filter) => {
        const statuses = filters[AvailableFilters.STATUS_NAME];
        let options = [];
        if (!statuses) {
            options.push(filter);
        }
        else {
            options = statuses.includes(filter)
                ? statuses.filter(i => i !== filter)
                : [...statuses, filter];
        }
        props.onChange({
            filterName: AvailableFilters.STATUS_NAME,
            filterValue: options
        });
    };
    const isJobStatusChecked = (filter) => {
        const statuses = filters[AvailableFilters.STATUS_NAME];
        return !statuses ? false : statuses.includes(filter);
    };
    return (React.createElement(DropdownButton, { title: "Job Status", id: "jobStatus", variant: "secondary" }, jobStatusMapping.map((item, index) => (React.createElement(Dropdown.Item, { eventKey: `${index + 1}`, key: item, onClick: () => selectFilter(item), active: isJobStatusChecked(item) },
        React.createElement(JobStatusIcon, { status: item }))))));
};
export default JobStatusFilter;
